// src/api.js
const API_BASE = "https://deposit-tracker.accounthingamid.workers.dev/api";

async function handleResponse(res, entity = "data") {
  if (!res.ok) {
    const msg = await res.text();
    throw new Error(`Failed to fetch ${entity}: ${res.status} ${msg}`);
  }
  return res.json();
}

// ===================== Events =====================
export async function getEvents() {
  const res = await fetch(`${API_BASE}/events`);
  return handleResponse(res, "events");
}

export async function addEvent(event) {
  const res = await fetch(`${API_BASE}/events`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(event),
  });
  return handleResponse(res, "event");
}

export async function deleteEvent(id) {
  const res = await fetch(`${API_BASE}/events/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Failed to delete event");
}

// ===================== Users =====================
export async function getUsers() {
  const res = await fetch(`${API_BASE}/users`);
  return handleResponse(res, "users");
}

export async function addUser(user) {
  const res = await fetch(`${API_BASE}/users`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
  });
  return handleResponse(res, "user");
}

export async function deleteUser(id) {
  const res = await fetch(`${API_BASE}/users/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Failed to delete user");
}

// ===================== Fiscal Years =====================
export async function getFiscalYears() {
  const res = await fetch(`${API_BASE}/fiscal-years`);
  return handleResponse(res, "fiscal years");
}

export async function addFiscalYear(year) {
  const res = await fetch(`${API_BASE}/fiscal-years`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(year),
  });
  return handleResponse(res, "fiscal year");
}

export async function deleteFiscalYear(id) {
  const res = await fetch(`${API_BASE}/fiscal-years/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Failed to delete fiscal year");
}
